import { gql } from "@apollo/client"
import { QueryCompanyArgs, Query } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

export const GET_COMPANY_PAYMENT_MANDATE_SETUP = gql`
  query CompanyPaymentMandateSetup($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentsSettings {
        paymentsMandateSetup
      }
    }
  }
`

type QueryArgs = QueryCompanyArgs

export const useCompanyPaymentMandateSetup = ({
  skip,
  variables,
}: {
  skip: boolean
  variables: QueryArgs
}) => useQuery<Pick<Query, "company">>(GET_COMPANY_PAYMENT_MANDATE_SETUP, { variables, skip })
